<template>
  <div id="restore-password-form">
    <div class="main-logo">
    </div>
    <div class="underlogo-title">
      <b>СБРОС ПАРОЛЯ</b>
    </div>
    <div v-if="showInputLogin">
      <div>
        <input type='text' placeholder='Введите логин' v-model="formData.username"/>
      </div>
      <ErrorAlert v-if="errorMessage && errorMessage.length" :message="errorMessage" />
      <div>
        <button
          :disabled="formData.username.length !== 10"
          class="btn"
          @click="resetPassw()"><spinner v-if="loader"/>Продолжить</button>
      </div>
    </div>
    <confirm-code-form
      ref="verify"
      :canEnterCode="confirmCodeData.canEnterCode"
      :lifetimeSeconds="confirmCodeData.expirationSeconds"
      :verifyCodeLength="confirmCodeData.confirmCodeLength"
      :loader="confirmCodeDataLoader"
      :showPasswordField="true"
      v-on:submit-code="confirmResetPasswd"
      v-on:request-new-code="resetPassw"
      v-if="confirmCodeRequired"
      />
  </div>
</template>

<script>
import VerificationCodeInput from './verification-code-input';
import ConfirmCodeForm from './ConfirmCodeForm';

export default {
  components: {
    VerificationCodeInput,
    ConfirmCodeForm,
  },
  data() {
    return {
      loader: false,
      errorMessage: '',
      formData: {
        username: '',
        password: '',
      },
      showInputLogin: true,
      confirmCodeDataLoader: true,
      confirmCodeRequired: false,
      confirmCodeData: {
        confirmCodeLength: 6,
        canEnterCode: true,
        expirationSeconds: 9999,
      },
    };
  },
  methods: {
    onInputKeyUp(e) {
      if (e.keyCode === 13) {
        this.resetPassw();
      }
    },
    resetPassw() {
      this.loader = true;
      this.confirmCodeDataLoader = true;
      const bodyData = {
        username: this.formData.username,
      };
      this.$http.post(`${this.$host.IdentityServiceApi}/ResetPassword`, bodyData, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json',
        },
      }).then(
        (response) => {
          this.loader = false;
          this.showVerifyForm(response.body);
        },
        () => {
          this.loader = false;
        },
      );
    },
    showVerifyForm(confirmCodeData) {
      if (confirmCodeData.displayMessage) {
        // toastr.info(confirmCodeData.displayMessage);
      }
      this.confirmCodeData = confirmCodeData;
      this.showInputLogin = false;
      this.confirmCodeDataLoader = false;
      this.confirmCodeRequired = true;
      this.$nextTick(() => {
        this.$refs.verify.resetInput();
      });
    },
    confirmResetPasswd(verifyCode, password) {
      this.confirmCodeRequired = true;

      const bodyData = {
        username: this.formData.username,
        newPassword: password,
        confirmCode: verifyCode,
      };

      this.$http.post(`${this.$host.IdentityServiceApi}/ConfirmResetPassword`, bodyData, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json',
        },
      }).then(
        (response) => {
          this.loader = false;
          const data = response.body;
          if (data && data.accessToken) {
            this.$emit('authenticated', data);
          }
        },
      ).catch(() => {
        this.showInputLogin = true;
        this.confirmCodeRequired = false;
        this.resetPassw();
      });
    },
  },
};
</script>

<style scoped src='@/assets/css/authorization.css'>
</style>
